;(function() {
  'use strict'

  Config.$inject = ["$stateProvider"];
  angular.module('app.core').config(Config)

  /* @ngInject */
  function Config($stateProvider) {
    $stateProvider.state('app.externalPanel', {
      url: '/external-panel/:id',
      templateUrl: 'external-panel.html',
      controller: 'ExternalPanel',
      controllerAs: '$ctrl',
    })
  }
})()
